import * as React from 'react';
import { styled } from '../theme-provider';
import { useTableContext } from './table';
const StyledTableRow = styled.tr.withConfig({ displayName: "StyledTableRow", componentId: "sc-117f1zq" }) `display:grid;grid-template-columns:repeat(${({ columnCount }) => columnCount}, 1fr);grid-column-gap:${({ theme }) => theme.size.static350};tfoot tr{border-bottom:${({ theme }) => theme.size.border.light} solid ${({ theme }) => theme.colors.border.default};padding-bottom:${({ theme }) => theme.size.static515};}`;
export const TableRow = ({ children }) => {
    const { columnCount = 1, setColumnCount } = useTableContext();
    React.useEffect(() => {
        const childrenCount = React.Children.count(children);
        if (childrenCount >= columnCount && setColumnCount) {
            setColumnCount(childrenCount);
        }
    }, [setColumnCount, children, columnCount]);
    return React.createElement(StyledTableRow, { columnCount: columnCount }, children);
};
